import { useEffect, useState } from 'react';

const heroSlides = [
  {
    image: "https://readdy.ai/api/search-image?query=Professional%20Black%20African%20painter%20craftsman%20working%20on%20luxury%20interior%20wall%20finishing%20in%20Lagos%20Nigeria%2C%20skilled%20Nigerian%20tradesperson%20with%20paint%20roller%2C%20warm%20cinematic%20lighting%2C%20high%20end%20residential%20space%2C%20focused%20Black%20man%20in%20work%20attire%2C%20premium%20quality%20paint%20job&width=1920&height=1080&seq=painter001&orientation=landscape",
    title: "Painters",
    subtitle: "Flawless Finishes"
  },
  {
    image: "https://readdy.ai/api/search-image?query=Professional%20Black%20African%20electrician%20installing%20modern%20lighting%20fixtures%20in%20luxury%20home%20in%20Lagos%20Nigeria%2C%20skilled%20Nigerian%20electrical%20tradesperson%20at%20work%2C%20warm%20cinematic%20lighting%2C%20high%20end%20residential%20space%2C%20focused%20Black%20man%20with%20electrical%20tools%2C%20premium%20wiring%20installation&width=1920&height=1080&seq=electrician001&orientation=landscape",
    title: "Electricians",
    subtitle: "Precision Wiring"
  },
  {
    image: "https://readdy.ai/api/search-image?query=Professional%20Black%20African%20plumber%20installing%20premium%20bathroom%20fixtures%20in%20luxury%20home%20in%20Lagos%20Nigeria%2C%20skilled%20Nigerian%20plumbing%20tradesperson%20at%20work%2C%20warm%20cinematic%20lighting%2C%20high%20end%20residential%20bathroom%2C%20focused%20Black%20man%20with%20plumbing%20tools%2C%20premium%20pipe%20installation&width=1920&height=1080&seq=plumber001&orientation=landscape",
    title: "Plumbers",
    subtitle: "Expert Installations"
  },
  {
    image: "https://readdy.ai/api/search-image?query=Professional%20Black%20African%20tiler%20laying%20premium%20marble%20floor%20tiles%20in%20luxury%20home%20in%20Lagos%20Nigeria%2C%20skilled%20Nigerian%20tile%20craftsman%20at%20work%2C%20warm%20cinematic%20lighting%2C%20high%20end%20residential%20space%2C%20focused%20Black%20man%20with%20tiling%20tools%2C%20precision%20tile%20work&width=1920&height=1080&seq=tiler001&orientation=landscape",
    title: "Tilers",
    subtitle: "Masterful Patterns"
  },
  {
    image: "https://readdy.ai/api/search-image?query=Professional%20Black%20African%20carpenter%20craftsman%20building%20custom%20wooden%20cabinets%20in%20luxury%20home%20in%20Lagos%20Nigeria%2C%20skilled%20Nigerian%20woodworking%20tradesperson%20at%20work%2C%20warm%20cinematic%20lighting%2C%20high%20end%20residential%20space%2C%20focused%20Black%20man%20with%20carpentry%20tools%2C%20premium%20woodwork&width=1920&height=1080&seq=carpenter001&orientation=landscape",
    title: "Carpenters",
    subtitle: "Custom Woodwork"
  }
];

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
        setIsTransitioning(false);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (showVideoModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showVideoModal]);

  const goToSlide = (index: number) => {
    if (index !== currentSlide) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide(index);
        setIsTransitioning(false);
      }, 500);
    }
  };

  return (
    <section className="relative min-h-screen w-full overflow-hidden bg-[#0A0A0A]">
      {/* Video Modal */}
      {showVideoModal && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm"
          onClick={() => setShowVideoModal(false)}
        >
          {/* Close Button */}
          <button 
            onClick={() => setShowVideoModal(false)}
            className="absolute top-6 right-6 md:top-10 md:right-10 w-12 h-12 flex items-center justify-center text-white/70 hover:text-[#C9A86C] transition-colors cursor-pointer z-10 group"
          >
            <div className="absolute inset-0 border border-white/20 group-hover:border-[#C9A86C]/50 transition-colors" />
            <i className="ri-close-line text-2xl" />
          </button>

          {/* Modal Header */}
          <div className="absolute top-6 left-6 md:top-10 md:left-10">
            <span className="text-[#C9A86C] text-xs tracking-[0.2em] uppercase block mb-1">Now Playing</span>
            <span className="text-white text-lg md:text-xl font-serif">Our Showreel</span>
          </div>

          {/* Video Container */}
          <div 
            className="relative w-[90%] max-w-5xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative Corners */}
            <div className="absolute -top-3 -left-3 w-8 h-8 border-t-2 border-l-2 border-[#C9A86C]" />
            <div className="absolute -top-3 -right-3 w-8 h-8 border-t-2 border-r-2 border-[#C9A86C]" />
            <div className="absolute -bottom-3 -left-3 w-8 h-8 border-b-2 border-l-2 border-[#C9A86C]" />
            <div className="absolute -bottom-3 -right-3 w-8 h-8 border-b-2 border-r-2 border-[#C9A86C]" />

            {/* Video Player */}
            <video
              autoPlay
              controls
              className="w-full h-full object-cover bg-black"
              poster="https://readdy.ai/api/search-image?query=Luxury%20interior%20construction%20finishing%20work%20in%20progress%2C%20premium%20home%20renovation%2C%20elegant%20craftsmanship%2C%20warm%20cinematic%20lighting%2C%20high%20end%20residential%20space%2C%20professional%20construction%20site%2C%20dark%20moody%20atmosphere&width=1920&height=1080&seq=showreel-poster&orientation=landscape"
            >
              <source src="https://videos.pexels.com/video-files/5974401/5974401-uhd_2560_1440_25fps.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Bottom Info */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center">
            <p className="text-white/50 text-sm">Press ESC or click outside to close</p>
          </div>
        </div>
      )}

      {/* Image Carousel Background */}
      <div className="absolute inset-0">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            } ${isTransitioning && index === currentSlide ? 'opacity-60' : ''}`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/50" />
      </div>

      {/* Decorative Elements - Hidden on mobile */}
      <div className="absolute top-0 right-0 w-1/3 h-full hidden lg:block">
        <div className="absolute top-1/4 right-20 w-px h-40 bg-gradient-to-b from-transparent via-[#C9A86C] to-transparent opacity-50" />
        <div className="absolute top-1/2 right-40 w-px h-60 bg-gradient-to-b from-transparent via-[#C9A86C] to-transparent opacity-30" />
      </div>

      {/* Slide Indicator - Current Trade */}
      <div className={`absolute top-32 right-8 md:right-16 z-20 transition-all duration-700 ${isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
        <div className="text-right">
          <span className="text-[#C9A86C] text-xs tracking-[0.2em] uppercase block mb-1">Featured Trade</span>
          <span className={`text-white text-2xl md:text-3xl font-serif transition-all duration-500 ${isTransitioning ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}`}>
            {heroSlides[currentSlide].title}
          </span>
          <span className={`text-white/60 text-sm block transition-all duration-500 delay-100 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}>
            {heroSlides[currentSlide].subtitle}
          </span>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex items-center pt-20 pb-32 md:pb-40">
        <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
          <div className="max-w-3xl">
            {/* Label */}
            <div className={`flex items-center gap-3 md:gap-4 mb-4 md:mb-8 transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <div className="w-8 md:w-12 h-px bg-[#C9A86C]" />
              <span className="text-[#C9A86C] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-medium">Luxury Construction Finishing</span>
            </div>

            {/* Headline */}
            <h1 className={`text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-serif text-white leading-[1.1] md:leading-[1.05] mb-4 md:mb-8 transition-all duration-1000 delay-200 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              Crafting
              <span className="block text-[#C9A86C]">Perfection</span>
              <span className="block text-white/60 text-3xl sm:text-4xl md:text-5xl lg:text-6xl mt-1 md:mt-2">In Every Detail</span>
            </h1>

            {/* Description */}
            <p className={`text-base md:text-lg text-white/70 leading-relaxed max-w-xl mb-8 md:mb-12 transition-all duration-1000 delay-400 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              We transform spaces into masterpieces. Premium finishing and interior furnishing for those who refuse to compromise on excellence.
            </p>

            {/* CTA Buttons */}
            <div className={`flex flex-col sm:flex-row gap-3 md:gap-5 transition-all duration-1000 delay-600 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <a 
                href="https://drive.google.com/drive/folders/1e158LBcGWaP_HSb0VsrJqnqna-SC7SlJ?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative px-6 md:px-10 py-3 md:py-4 bg-[#C9A86C] text-[#0A0A0A] font-semibold tracking-wide overflow-hidden transition-all duration-500 hover:shadow-[0_0_40px_rgba(201,168,108,0.3)] whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3">
                  View Our Projects
                  <i className="ri-arrow-right-up-line text-lg md:text-xl transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
                <div className="absolute inset-0 bg-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
              </a>
              
              <button 
                onClick={() => setShowVideoModal(true)}
                className="group px-6 md:px-10 py-3 md:py-4 border border-white/30 text-white font-medium tracking-wide transition-all duration-500 hover:border-[#C9A86C] hover:text-[#C9A86C] whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <span className="flex items-center justify-center gap-2 md:gap-3">
                  <i className="ri-play-circle-line text-lg md:text-xl group-hover:scale-110 transition-transform" />
                  Watch Showreel
                </span>
              </button>
            </div>

            {/* Carousel Navigation Dots */}
            <div className={`flex items-center gap-3 mt-10 md:mt-14 transition-all duration-1000 delay-700 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`relative h-2 rounded-full transition-all duration-500 cursor-pointer ${
                    index === currentSlide 
                      ? 'w-10 bg-[#C9A86C]' 
                      : 'w-2 bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                >
                  {index === currentSlide && (
                    <span className="absolute inset-0 rounded-full bg-[#C9A86C] animate-pulse" />
                  )}
                </button>
              ))}
              <span className="text-white/40 text-xs ml-3">
                {String(currentSlide + 1).padStart(2, '0')} / {String(heroSlides.length).padStart(2, '0')}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className={`absolute bottom-0 left-0 right-0 border-t border-white/10 bg-[#0A0A0A]/80 backdrop-blur-sm transition-all duration-1000 delay-800 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-16 py-4 md:py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
            {/* Stats */}
            <div className="flex items-center justify-center gap-6 sm:gap-8 md:gap-16 w-full md:w-auto">
              <div className="group cursor-pointer text-center md:text-left">
                <span className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#C9A86C] group-hover:scale-110 inline-block transition-transform">15+</span>
                <p className="text-white/50 text-xs md:text-sm mt-1">Years Experience</p>
              </div>
              <div className="w-px h-8 md:h-12 bg-white/10 hidden sm:block" />
              <div className="group cursor-pointer text-center md:text-left">
                <span className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#C9A86C] group-hover:scale-110 inline-block transition-transform">200+</span>
                <p className="text-white/50 text-xs md:text-sm mt-1">Projects Delivered</p>
              </div>
              <div className="w-px h-8 md:h-12 bg-white/10 hidden sm:block" />
              <div className="group cursor-pointer text-center md:text-left">
                <span className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#C9A86C] group-hover:scale-110 inline-block transition-transform">50+</span>
                <p className="text-white/50 text-xs md:text-sm mt-1">Expert Craftsmen</p>
              </div>
            </div>
            
            {/* Scroll indicator - Hidden on mobile */}
            <div className="hidden lg:flex items-center gap-3 text-white/50 cursor-pointer hover:text-[#C9A86C] transition-colors">
              <span className="text-sm tracking-widest">SCROLL TO EXPLORE</span>
              <div className="w-6 h-10 border border-white/30 rounded-full flex items-start justify-center p-2">
                <div className="w-1 h-2 bg-[#C9A86C] rounded-full animate-bounce" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
